export type PersonaTheme = {
	accent: 'blue' | 'clay' | 'mist' | 'olive' | 'stone';
	eyebrow: string;
	name: 'admin' | 'auth' | 'employer' | 'patient' | 'pharmacy' | 'provider';
};

const getPath = () => (typeof window === 'undefined' ? '' : window.location.pathname.toLowerCase());

export const getPersonaTheme = (): PersonaTheme => {
	const path = getPath();

	if (path.includes('/admin')) {
		return {name: 'admin', accent: 'stone', eyebrow: 'Allora Admin'};
	}

	if (path.includes('/employer')) {
		return {name: 'employer', accent: 'olive', eyebrow: 'Employer Portal'};
	}

	if (path.includes('/provider')) {
		return {name: 'provider', accent: 'blue', eyebrow: 'Provider Portal'};
	}

	if (path.includes('/pharmacy')) {
		return {name: 'pharmacy', accent: 'mist', eyebrow: 'Pharmacy Portal'};
	}

	if (path.includes('/patient')) {
		return {name: 'patient', accent: 'clay', eyebrow: 'Patient Portal'};
	}

	return {name: 'auth', accent: 'clay', eyebrow: 'Allora Health'};
};

const themeColor = () => getPersonaTheme().accent;

export default themeColor;
